import * as React from "react";
import styled from "styled-components";

import { Text } from "@hubper/core-ui/elements";
import { Range as Slider } from "@hubper/core-ui/components/Slider";

const Base = styled.div`
  flex: 1 1 auto;
  padding: 0 8px;
`;

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

type Value = {
  min: number;
  max: number;
};

type Props = {
  min: number;
  max: number;
  value: Value;
  onChange: (value: Value) => void;
};

function Range({ min, max, value, onChange }: Props) {
  return (
    <Base data-testid="range-filter">
      <Slider
        min={min}
        max={max}
        value={[value.min, value.max]}
        onChange={([min, max]) => {
          onChange({ min, max });
        }}
      />
      <Labels>
        <Text c={["grey", 5]} fs={-3}>
          {value.min}
        </Text>
        <Text c={["grey", 5]} fs={-3}>
          {value.max}
        </Text>
      </Labels>
      {process.env.NODE_ENV === "test" && (
        <div
          data-testid="slider-fake"
          style={{ width: 10, height: 10 }}
          onClick={() => onChange({ min: 50, max: 100 })}
        />
      )}
    </Base>
  );
}

export default Range;
